export const YES_OR_NO = [
  { label: 'Yes', value: 'Yes', id: 'Yes' },
  { label: 'No', value: 'No', id: 'No' },
]

export const GROSS_OR_NET = [
  { label: 'Gross', value: 'Gross', id: 'Gross' },
  { label: 'Net', value: 'Net', id: 'Net' },
]

export const REBALANCING_FREQUENCY_OPTIONS = [
  { id: 'Daily', label: 'Daily', value: 'Daily' },
  { id: 'Monthly', label: 'Monthly', value: 'Monthly' },
  { id: 'Quarterly', label: 'Quarterly', value: 'Quarterly' },
  { id: 'Annually', label: 'Annually', value: 'Annually' },
  { id: 'Semi-Annually', label: 'Semi-Annually', value: 'Semi-Annually' },
  { id: 'Single Benchmark', label: 'Single Benchmark', value: 'Single Benchmark' },
]

export const DISCLOSURE_DESCRIPTION_OPTIONS = [
  { id: 'Composites Only', label: 'Composites Only', value: 'Composites Only' },
  {
    id: 'Limited Distribution Pooled Funds Only',
    label: 'Limited Distribution Pooled Funds Only',
    value: 'Limited Distribution Pooled Funds Only',
  },
  {
    id: 'Broad Distribution Pooled Funds Only',
    label: 'Broad Distribution Pooled Funds Only',
    value: 'Broad Distribution Pooled Funds Only',
  },
  {
    id: 'Composites & Limited Distribution Pooled Funds Only',
    label: 'Composites & Limited Distribution Pooled Funds Only',
    value: 'Composites & Limited Distribution Pooled Funds Only',
  },
  {
    id: 'Composites & Broad Distribution Pooled Funds Only',
    label: 'Composites & Broad Distribution Pooled Funds Only',
    value: 'Composites & Broad Distribution Pooled Funds Only',
  },
  {
    id: 'Broad Distribution Pooled Funds and Limited Distribution Pooled Funds Only',
    label: 'Broad Distribution Pooled Funds and Limited Distribution Pooled Funds Only',
    value: 'Broad Distribution Pooled Funds and Limited Distribution Pooled Funds Only',
  },
  { id: 'All Three', label: 'All Three', value: 'All Three' },
]

export const REPORT_OPTIONS = [
  { label: 'Default', value: 'Default', id: 'Default' },
  { label: 'Design 1', value: 'Design 1', id: 'Design 1' },
  { label: 'Design 2', value: 'Design 2', id: 'Design 2' },
]

export const ORIENTATION = [
  { label: 'Landscape', value: 'Landscape', id: 'Landscape' },
  { label: 'Portrait', value: 'Portrait', id: 'Portrait' },
]

export const STATISTICS_EXPORT_OPTIONS = [
  { id: 'advertising', label: 'Advertising Stats', value: 'advertising' },
  { id: 'gips', label: 'GIPS Stats', value: 'gips' },
  { id: 'sec', label: 'SEC Stats', value: 'sec' },
  { id: 'growth', label: 'Growth', value: 'growth' },
  { id: 'drawdown_portfolio', label: 'Drawdown Portfolio', value: 'drawdown_portfolio' },
  { id: 'drawdown_benchmark', label: 'Drawdown Benchmark', value: 'drawdown_benchmark' },
  { id: 'annual', label: 'Annual Report', value: 'annual' },
  { id: 'monthly_quarterly', label: 'Monthly & Quarterly', value: 'monthly_quarterly' },
  { id: 'rolling', label: 'Rolling Returns', value: 'rolling' },
  { id: 'rolling_benchmark', label: 'Rolling Benchmark', value: 'rolling_benchmark' },
  { id: 'issues', label: 'Potential Issues', value: 'issues' },
  { id: 'inclusion', label: 'Inclusion & Exclusion', value: 'inclusion' },
  { id: 'portfolio_data', label: 'Portfolio Data', value: 'portfolio_data' },
  { id: 'account_data', label: 'Account Data', value: 'account_data' },
  { id: 'benchmark_data', label: 'Benchmark Data', value: 'benchmark_data' },
  { id: 'dispersion_support', label: 'Dispersion Support', value: 'dispersion_support' },
  { id: 'rules', label: 'Rules', value: 'rules' },
]
